const PageUrls = {
  Home: '/',
  CRM: {
    Pipeline: '/crm/pipeline',
    Lead: {
      Import: '/crm/lead/import',
      List: '/crm/lead/list',
      Cancel: '/crm/lead/cancel',
      Follow: '/crm/lead/follow',
      Calender: '/crm/lead/calendar',
      Notification: '/crm/lead/notification',
      Detail: '/crm/lead/detail',
    },
  },
  Report: {
    Index: '/reports',
    DailyOrders: '/reports/orders-daily',
    DailySales: '/reports/sales-daily',
    SendItems: '/reports/send-items',
    Calendar: '/reports/calendar',
    Commission: '/reports/commission',
    CommissionCancelled: '/reports/commission-cancelled',
    CodChecker: '/reports/cod-checker',
    Custormer: '/reports/customer',
  },
  Logout: '/logout',
  Login: '/login',
  Expenses: '/expenses',
  Users: '/users',
  Chats: '/chats',
  Broadcast: '/broadcast/facebook-tools',
  Merchant: '/merchants',
  Tracking: '/tracking',
  TrackingPrinted: '/tracking/printed',
  Product: '/products',
  Stock: '/stock',
  Category: '/categories',
  ProductGroup: '/product-groups',
  Chat: {
    Facebook: '/chat/facebook',
  },
  Facebook: {
    UserInfo: '/facebook/user-info',
  },
  Ai: {
    notify: '/ai/notify',
  },
  Orders: {
    Index: '/orders',
    Ai: '/orders/ai',
    Telesale: '/orders/telesale',
    SalePage: '/orders/salepage',
    Create: '/orders/create',
    QuickCreate: '/orders/quick-create',
    QuickCreateOld: '/orders/quick-create-old',
    Detail: '/orders/detail',
    PlatformDetail: '/orders/platform/detail',
    ImportExcel: '/orders/import-excel',
  },
  Platforms: {
    Index: '/platforms',
    Tiktok: '/platforms/tiktok',
    TiktokSalesReport: '/platforms/tiktok/sales-report',
    TiktokSaleOrderDetail: '/platforms/tiktok/sales-report/order', // + /:orderId
    // รายละเอียดการตัดสต๊อกรายวัน — + /:date?platform=&shopId=
    TiktokStockReportDetail: '/platforms/tiktok/sales-report/stock',
    ShopeeSalesReport: '/platforms/shopee/sales-report',
    ShopeeStockReportDetail: '/platforms/shopee/sales-report/stock',
  },
  Setting: {
    Index: '/setting',
    DistributionChannels: '/setting/distribution-channel',
    Address: '/setting/address',
    ChatIntegrations: '/setting/chat-integrations',
    ShippingSettings: '/setting/shipping-settings',
  },
  Popup: {
    FacebookPageLists: '/popup/chat-integrations/pages',
  },
  Marketplace: {
    Shope: {
      Shopee: {
        Index: '/marketplace/shopee/login',
        Order: '/marketplace/shopee/order',
      },
      Tiktok: {
        Index: '/marketplace/tiktok/login',
        Order: '/marketplace/tiktok/order',
      },
      Lazada: {
        Index: '/marketplace/lazada/login',
        Order: '/marketplace/lazada/order',
      },
      LineMyShop: {
        Index: '/marketplace/line-my-shop/login',
        Order: '/marketplace/line-my-shop/order',
      },
    },
  },
  Customer: {
    BlackList: '/customers/black-list',
  },
  Salepage: {
    Index: '/salepage',
    Create: '/salepage/create',
    Detail: '/salepage/detail',
    Preview: '/salepage/preview',
  },
}

export default PageUrls
